import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from '../header';
import { adminTransmissionGroups_template } from '../../components/templates/recruiting/adminTransmissionGroups_template';
import { hideLoadingOverlay, showLoadingOverlay } from '~/utils/listLoading';
export class admin_transmission_groups extends vnModule_knockoutJS {
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_transmission_groups';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Transmission Groups');
        this.tpl = new adminTransmissionGroups_template('adminTransmissionGroupsTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    /**
     * Load the initial data required by the page.
     *
     * @return void
     */
    fillPage() {
        showLoadingOverlay(this.tpl.builtTemplate, 'Loading transmission groups...');
        const req = new XMLHttpRequestHandler('/api/admin/rest/api/lead/transmission/scheduling/groups', [], this);
        req.onReadyStateFunction = this.onGroupsReturn;
        req.execute();
    }
    /**
     * Handle the API response for groups.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onGroupsReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.tpl.setGroups(JSON.parse(req.request.response || '[]'));
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                hideLoadingOverlay(obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Navigate to create group.
     *
     * @return void
     */
    createGroup() {
        page('/admin/transmissionGroup/new');
    }
    /**
     * Navigate to edit group.
     *
     * @param id number
     * @return void
     */
    editGroup(id) {
        page('/admin/transmissionGroup/' + id);
    }
    /**
     * Navigate back to transmissions.
     *
     * @return void
     */
    backToTransmissions() {
        page('/admin/transmissions');
    }
}
